import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Projects from './pages/Projects';
import About from './pages/About';
import WhyWe from './pages/WhyWe';
import Rent from './pages/Rent';
import Contact from './pages/Contact';
import Footer from './components/Footer';
import BackToTop from './components/BackToTop';
import WhatsAppFloat from './components/WhatsAppFloat';
import SplashScreen from './components/SplashScreen';
import NewServicePromo from './components/NewServicePromo';
import './App.css';

// ScrollToTop component
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

const PROMO_DELAY_AFTER_LOAD_MS = 2000;

function App() {
  const [showSplash, setShowSplash] = useState(true);
  const [showRentPromo, setShowRentPromo] = useState(false);

  useEffect(() => {
    if (showSplash) return undefined;

    let promoTimer;

    const schedulePromo = () => {
      promoTimer = setTimeout(() => setShowRentPromo(true), PROMO_DELAY_AFTER_LOAD_MS);
    };

    if (document.readyState === 'complete') {
      schedulePromo();
    } else {
      window.addEventListener('load', schedulePromo, { once: true });
    }

    return () => {
      window.removeEventListener('load', schedulePromo);
      clearTimeout(promoTimer);
    };
  }, [showSplash]);

  return (
    <Router>
      <div className="App">
        {showSplash && <SplashScreen onComplete={() => setShowSplash(false)} />}
        {!showSplash && (
          <>
            <ScrollToTop />
            <Navbar />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/projects" element={<Projects />} />
              <Route path="/about" element={<About />} />
              <Route path="/why-we" element={<WhyWe />} />
              <Route path="/rent" element={<Rent />} />
              <Route path="/contact" element={<Contact />} />
            </Routes>
            <Footer />
            <WhatsAppFloat />
            <BackToTop />
            {showRentPromo && (
              <NewServicePromo onClose={() => setShowRentPromo(false)} />
            )}
          </>
        )}
      </div>
    </Router>
  );
}

export default App;